/**
 * @typedef {import('./Response').default} Response
 * @typedef {import('../../../../App/Admin/Users/Admins/Admin').default} Admin
 */

import { administratorService } from '../../../../service-container';
import { translate } from '../../../../App/Internationalization';
import { useEffect, useMemo, useState } from 'react';
import captureError from '../../../../utils/captureError';

/**
 * @param {boolean} [isGated]
 * @returns {Response}
 */
export default function useGetAdminsPersonalData(isGated = false) {
	const [errorMessage, setErrorMessage] = useState('');
	const [isGettingData, setIsGettingData] = useState(true);
	const [admin, setAdmin] = useState(/** @type {Admin | null} */ (null));

	useEffect(() => {
		if (isGated) {
			setIsGettingData(false);
			return;
		}

		fetchData();
	}, [isGated]);

	/** @returns {Promise<void>} */
	async function fetchData() {
		setIsGettingData(true);

		try {
			const response =
				await administratorService.getAdministratorPersonalData();

			setAdmin(response);
		} catch (error) {
			captureError(error);
			setErrorMessage(translate('global.error'));
		} finally {
			setIsGettingData(false);
		}
	}

	return useMemo(
		() => ({
			data: admin,
			errorMessage,
			isGettingData,
		}),
		[admin, errorMessage, isGettingData]
	);
}
